var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('k-text',{staticClass:"font-weight-bold",attrs:{"text":_vm.item.name}}),_c('k-text',{attrs:{"text":_vm.item.ownerName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }